import { render, staticRenderFns } from "./PointListView.vue?vue&type=template&id=ea8f5558&scoped=true"
import script from "./PointListView.vue?vue&type=script&lang=js"
export * from "./PointListView.vue?vue&type=script&lang=js"
import style0 from "./PointListView.vue?vue&type=style&index=0&id=ea8f5558&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8f5558",
  null
  
)

export default component.exports